import * as React from "react";
import Link from "../../modules/Link";
import FooterService from "./FooterService";
import {FormattedMessage} from "react-intl";

export default class Footer extends React.Component<{}> {

    public render(): React.ReactNode {
        return (
            <footer>

                <div className={"links"}>
                    <div className={"flex-container"}>
                        {this.renderLinkFooter()}
                    </div>
                </div>
                <div className={"info"}>
                    <span className={"font-weight-bold"}><FormattedMessage id={"club-name"}/></span> <br/>
                    <FormattedMessage id={"club-direction"}/>
                </div>

                <div className={"footer-line"}/>
            </footer>
        )
    }

    private renderLinkFooter(): React.ReactNode {
        return (
            FooterService.getFooterLinks().map((link, index: number) => (
                <div key={index}
                     className={"flex-item"}>
                    <img src={link.src} alt={link.alt} onClick={() => Link.onWindowOpen(link.link)}/>
                </div>
            ))
        )
    }
}